module.exports = __webpack_public_path__ + "img/co_wrapbg1.e611779a.png";